import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import { getErrorsMessage, getSuccessMessage } from '../utils.js';
import { LangContext } from "../LangContext.jsx";
import ReplaceDocumentTemplante from "./ReplaceDocumentTemplate.jsx";
import TemplateDocumentRequestModal from "./TemplateDocumentRequestModal.jsx";
class DossierView extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            dossier: null,
        };
        this.confirmDelete = this.confirmDelete.bind(this);
        this.delete = this.delete.bind(this);
        this.replaceDocumentTemplateRef = React.createRef();
        this.documentRequestRef = React.createRef();
    }

    async componentDidMount() {
        this.getDossier()
    }

    async getDossier() {
        const res = await axios.get('/api/dossiers/' + this.props.dossier_id)
        this.setState({dossier: res.data})
    }

    confirmDelete() {
        swal.fire({
            text: "¿Desea continuar con el borrado?",
            showCancelButton: true,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Continuar",
            cancelButtonText: "Cancelar",
            customClass: {
                confirmButton: "btn font-weight-bold btn-danger",
                cancelButton: "btn font-weight-bold btn-secondary"
            }
        }).then((result) => {
            if (result.isConfirmed) {
                this.delete();
            }
        });
    }

    async delete() {
        window.blockUI(); 
        await axios.delete(
            '/api/dossiers/' + this.props.dossier_id,
            {
                "headers": {
                    "content-type": "application/json",
                },
            }
        ).then((response) => {
            window.unblockUI();
            KTUtil.btnRelease(KTUtil.getById('btnDelete'));

            swal.fire({
                text: getSuccessMessage(response),
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                },
                timer: 3000
            }).then(function(result) {
                window.location.href = '/dossiers';
            });
        }).catch((error) => {
            window.unblockUI();
            const message = getErrorsMessage(error);
            KTUtil.btnRelease(KTUtil.getById('btnDelete')); 
            swal.fire({
                text: message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            });
        });
    }
    openReplaceDocumentModal = ()=>{ 
        if(this.replaceDocumentTemplateRef.current){
            this.replaceDocumentTemplateRef.current.handleOpenModalReplaceDocument();
        }
    }
    render() {
        const { lang } = this.context; 
        return (
            <form id="frm">
                <ReplaceDocumentTemplante level="dossier_template" dossier_id={this.props.dossier_id} ref={this.replaceDocumentTemplateRef} />    
                <TemplateDocumentRequestModal dossierId={this.props.dossier_id} ref={this.documentRequestRef} />
                <div className="subheader py-6 py-lg-8 subheader-transparent" id="kt_subheader">
                    <div className="container d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
                        <div className="d-flex align-items-center flex-wrap mr-1">
                            <div className="d-flex align-items-baseline flex-wrap mr-5">
                                <h5 className="text-dark font-weight-bold my-1 mr-5">
                                    {this.state.dossier != null ? this.state.dossier.title : ''}
                                </h5>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="d-flex flex-column-fluid">
                    <div className="container">

                        <div className="row justify-content-center text-left">
                            <div className="col-sm-4 form-group">
                                <div><strong>{this.state.dossier!=null ? this.state.dossier.target.name : ''}</strong></div>
                                <div className="text-dark-50">Para quien es</div>
                            </div>
                            <div className="col-sm-4 form-group">
                                <div><strong>{this.state.dossier!=null ? this.state.dossier.type.title : ''}</strong></div>
                                <div className="text-dark-50">{lang.get('messages.tipo_de_expediente')}</div>
                            </div>
                            <div className="col-sm-4 text-right"> 
                                <div className="dropdown dropdown-inline">
                                    <a href="#" className="btn btn-fixed-height btn-primary font-weight-bolder font-size-sm px-5" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {lang.get('messages.acciones')}
                                        &nbsp;&nbsp;
                                        <i className="flaticon2-down icon-sm"></i>
                                    </a>
                                    <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0 m-0 rounded-lg" style={{ background: '#F0E9FF' }}> 
                                        <ul className="navi navi-hover">
                                            <li className="navi-item">
                                                <a href="#" className="navi-link py-4" onClick={(event) => {
                                                    event.preventDefault();
                                                    this.documentRequestRef.current.open();
                                                }}>
                                                    <span className="navi-icon mr-5 text-center">
                                                        <span className="flaticon2-file text-primary icon-md"></span>
                                                    </span>
                                                    <span className="navi-text text-secondary">Solicitar documentos</span>
                                                </a>
                                            </li>
                                        {this.props.permissions != undefined &&
                                        <>
                                            <li className="navi-item">
                                                <a  href={"/dossiers/new?d=" + this.props.dossier_id} >
                                                <span role="button" onClick={() => this.resendInvitation()}  className="navi-link py-4 cursor">
                                                    <span className="navi-icon mr-5 text-center">
                                                        <span className="flaticon2-mail text-primary icon-md"></span>
                                                    </span>
                                                    <span className="navi-text text-secondary"> {lang.get('messages.duplicar_plantilla_de_expediente')}</span>
                                                    <span className="navi-icon pull-right">
                                                        <button className="btn btn-icon btn-light btn-xs bg-white">
                                                            <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                                        </button>
                                                    </span>
                                                </span>
                                                </a>
                                            </li>
                                            </>}
                                            <li className="navi-item">
                                                <a  href="#" >
                                                <span role="button" onClick={()=>{ this.openReplaceDocumentModal() }}  className="navi-link py-4 cursor">
                                                    <span className="navi-icon mr-5 text-center">
                                                        <span className=" flaticon-interface-4 text-primary icon-md"></span>
                                                    </span>
                                                    <span className="navi-text text-secondary"> Reemplazar plantilla de documento</span>
                                                    <span className="navi-icon pull-right">
                                                        <button className="btn btn-icon btn-light btn-xs bg-white">
                                                            <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                                        </button>
                                                    </span>
                                                </span>
                                                </a>
                                            </li>
                                            { this.props.permissions != undefined &&
                                                <>
                                                {( this.props.permissions.dossiers.includes('all') || this.props.permissions.dossiers.includes('delete') ) &&
                                                    <li className="navi-item">
                                                    <a  onClick={this.confirmDelete} className="navi-link py-4"    >
                                                    
                                                    <span className="navi-icon mr-5 text-center">
                                                        <span className="flaticon2-calendar-9 text-primary icon-md"></span>
                                                    </span>
                                                    
                                                        <span className="navi-text text-secondary"> {lang.get('messages.borrar_plantilla_de_expediente')} </span>
                                                        <span className="navi-icon pull-right">
                                                            <button id="btnDelete" className="btn btn-icon btn-light btn-xs bg-white">
                                                                <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                                            </button>
                                                        </span> 
                                                    </a>
                                                </li> 
                                                } 
                                            </>
                                            }
                                        </ul>
                                    </div> 
                                </div> 
                            </div>
                        </div>
                        <br />

                        <div className="card card-custom gutter-b">
                            <div className="card-body">
                                <div className="text-dark-50 mb-9 float-right">
                                    <strong>{lang.get('messages.fecha_de_creacion')}: { this.state.dossier!=null ? moment(this.state.dossier.created_at.split(' ')[0]).format('DD/MM/YYYY') : '' }</strong>
                                </div>
                                <div className="text-dark-50 mb-9">
                                    <strong>{lang.get('messages.listado_de_documentos_del_expediente')} </strong>
                                </div>
                                <div>
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>{lang.get('messages.nombre')}</th>
                                                <th>{lang.get('messages.frecuencia')}</th>
                                                <th>{lang.get('messages.formatos')}</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {this.state.dossier?.documents.map(({id, title, period , mimes}, i) => {
                                        return (<tr>
                                            <td key={i} className="pl-0 py-5 text-dark-75 font-weight-bolder font-size-lg d-flex align-items-center gap-1">
                                                <span>
                                                    <i className="fa fa-check icon text-primary mr-5 font-size-xs"></i>
                                                    {title}
                                                </span>
                                            </td>
                                            <td><span className="text-dark-50 mb-1 font-size-lg ">{period}</span></td>
                                            <td>
                                                <span className="text-muted font-weight-bold">
                                                    {
                                                        mimes.map((mime, i, {length}) => {
                                                            if (length - 1 === i) {
                                                                return mime.mime.toUpperCase()
                                                            } else {
                                                                return mime.mime.toUpperCase() + ', '
                                                            }
                                                        })
                                                    }
                                                </span>
                                            </td>
                                        </tr>);
                                        })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </form>
        );
    }
}

export default DossierView;

if (document.getElementById('DossierView')) {
    ReactDOM.render(<DossierView />, document.getElementById('DossierView'));
}
